import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const CellWithDoorSensorIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 16 16"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_21207_2709)">
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M11.2969 0.0375977C11.1903 0.22033 11.1023 0.409843 11.0332 0.604004C10.577 0.390719 10.0486 0.323939 9.52018 0.44515L9.39909 0.4764C8.84977 0.632794 8.38459 0.977981 8.07096 1.42952C7.57917 1.11321 6.96944 0.981059 6.35417 1.10205L6.23307 1.12939C5.01788 1.43442 4.20144 2.6533 4.44922 3.92367L4.44857 3.92432C4.69095 5.16982 5.17091 6.36864 5.88021 7.44385V14.326H7.18034V9.01742C7.43078 9.26142 7.69653 9.49447 7.97852 9.71403C8.2512 9.92634 8.53266 10.1206 8.82031 10.2987V14.326H10.1198V10.9686C10.6537 11.1944 11.2023 11.3693 11.7598 11.494V14.326H13.0599V11.6938C13.5247 11.7335 13.9913 11.7424 14.4564 11.7166H14.4629C14.5431 11.7119 14.6222 11.703 14.6999 11.6906V14.326H15.2298C15.6498 14.326 16 14.7092 16 15.1821C15.9999 15.6549 15.6597 16.0376 15.2298 16.0376H0.770182C0.350265 16.0376 0.000137344 15.6549 0 15.1821C0 14.7092 0.340182 14.326 0.770182 14.326H1.30013V1.74919H0.770182C0.350182 1.74919 0 1.36597 0 0.893066C0.000134216 0.420288 0.340267 0.0375977 0.770182 0.0375977H11.2969ZM2.9401 14.326H4.24023V1.74919H2.9401V14.326Z"
               fill="currentColor"
            />
            <path
               d="M6.63867 2.74593C7.01711 2.65096 7.38617 2.88457 7.46094 3.26351C7.76242 4.80875 8.57984 6.23654 9.89128 7.25765C11.2026 8.27868 12.785 8.72344 14.3587 8.6346C14.7444 8.61407 15.0594 8.91267 15.0625 9.30453C15.0632 9.69472 14.7522 10.0296 14.3646 10.0526C12.4774 10.1573 10.5736 9.62214 9.0026 8.39893C7.43159 7.1757 6.44632 5.4612 6.08529 3.60596C6.01065 3.22693 6.26022 2.84096 6.63867 2.74593Z"
               fill="currentColor"
            />
            <path
               d="M9.85547 2.07926C10.2327 1.97193 10.607 2.19428 10.694 2.57145C10.8708 3.35481 11.2993 4.07076 11.9674 4.59098C12.6356 5.11121 13.4348 5.35118 14.2376 5.33057C14.6246 5.32245 14.9299 5.62941 14.9206 6.02327C14.911 6.41692 14.5905 6.73983 14.2018 6.75049C13.0996 6.7786 11.9974 6.44808 11.0788 5.73291C10.1601 5.0176 9.56914 4.02985 9.32617 2.95426C9.23933 2.57713 9.47824 2.18664 9.85547 2.07926Z"
               fill="currentColor"
            />
            <path
               d="M12.8626 0.689941C13.4363 -0.0468851 14.4988 -0.17928 15.2357 0.394368C15.9725 0.968084 16.1049 2.03056 15.5312 2.76742C14.9576 3.50423 13.8951 3.6366 13.1582 3.06299C12.4214 2.4893 12.289 1.42679 12.8626 0.689941Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_21207_2709">
               <rect
                  width="16"
                  height="16"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default CellWithDoorSensorIcon
